import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../../booking/IDCard.vue.js';
import { usePortalStore } from '../../store/portal/index.js';
import { getLocation } from '../../../../../functions/location.js';

var script = defineComponent({
    name: 'ItineraryFlowNurseIdentity',
    components: {
        IDCard: __vue_component__,
    },
    setup() {
        const portalStore = usePortalStore();
        const nurse = computed(() => portalStore.itinerary.getters.assignedNurse());
        const info = computed(() => { var _a; return (_a = nurse.value) === null || _a === void 0 ? void 0 : _a.info; });
        const picture = computed(() => { var _a, _b; return (_b = (_a = info.value) === null || _a === void 0 ? void 0 : _a.picture) !== null && _b !== void 0 ? _b : ''; });
        const name = computed(() => {
            var _a, _b;
            const firstName = (_a = info.value) === null || _a === void 0 ? void 0 : _a.firstName;
            const lastName = (_b = info.value) === null || _b === void 0 ? void 0 : _b.lastName;
            return `${firstName} ${lastName}`;
        });
        const title = computed(() => { var _a, _b, _c; return (_c = (_b = (_a = nurse.value) === null || _a === void 0 ? void 0 : _a.professionalInfo) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : ''; });
        const state = computed(() => {
            var _a, _b, _c, _d;
            if (((_b = (_a = info.value) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.addressComponents) === undefined)
                return '';
            return getLocation((_d = (_c = info.value) === null || _c === void 0 ? void 0 : _c.address) === null || _d === void 0 ? void 0 : _d.addressComponents).state;
        });
        return {
            name,
            picture,
            state,
            title,
            nurse,
        };
    },
});

export { script as default };
